import React from 'react';
import { StyleSheet, View } from 'react-native';
import getSymbolFromCurrency from 'currency-symbol-map';
import { rem, CurrencyAmountText } from 'design-system';
import Text from 'design-system/Text';
import { useAppSelector } from 'store/hooks';
import { selectDefaultCurrency } from 'reducers/selectors';
const ClaimRewardsTopContainer = ({ redemptions = {}, selectedIndex, }) => {
    const defaultCurrency = useAppSelector(selectDefaultCurrency);
    const { available, pending } = redemptions;
    let balance = 0;
    if (redemptions && redemptions.pending) {
        balance = !selectedIndex
            ? pending?.balance
            : available?.balance;
    }
    let title = !selectedIndex ? 'Pending' : 'Available';
    if (selectedIndex && balance < 5)
        title = `${getSymbolFromCurrency(available?.currency)}5 threshold not reached`;
    return (<View>
      <View style={styles.textContainer}>
        <CurrencyAmountText size="XL" value={{
            amount: balance,
            currency: available?.currency || defaultCurrency,
        }}/>
        <Text TextThin-14 Secondary>
          {title}
        </Text>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    textContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: rem(32),
        paddingBottom: rem(8),
    },
});
export default React.memo(ClaimRewardsTopContainer);
